import {
  Card,
  CardContent,
  CardMedia,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { Box, Grid, Stack } from "@mui/system";
import { StyledImage } from "../../StyledImage";
import VerticalLinearStepper from "../VerticalLinearStepper";

export const KdappontLesson1 = () => {
  const blocks = [
    {
      label: "1. HTML",
      image: "html.jpeg",
      sub: "Geraamte | De bouwstenen",
    },
    {
      label: "2. CSS",
      image: "css.jpeg",
      sub: "Opmaak | De verf en het behang",
    },
    {
      label: "3. Code schrijven m.b.v. AI",
      image: "ai.jpeg",
      sub: "Nu al niet meer weg te denken",
    },
    {
      label: "4. Examen",
      image: "examen.jpeg",
      sub: "Laat maar zien!",
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "🧠 Wat gaan we doen? ",
          description: ``,
          content: (
            <Stack gap={5}>
              <Grid container spacing={2}>
                {blocks.map((x) => (
                  <Grid size={3}>
                    <Card color="primary">
                      <CardContent>
                        <Typography variant="h5">{x.label}</Typography>
                      </CardContent>
                      <CardMedia
                        component="img"
                        height="194"
                        image={`/presentation-data/KDAPPONT2/intro/${x.image}`}
                      />
                      <CardContent>{x.sub}</CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              <Box>
                <Typography variant="h4">Wat kun je ermee?</Typography>
                <Typography variant="body1">
                  Aan het einde van het jaar weet je hoe je zelf een simpele
                  webpagina maakt en online zet. Handig voor later. Bijvoorbeeld
                  voor een portfolio of een eventpagina.
                </Typography>
              </Box>

              <Box>
                <Typography variant="h5">
                  🙋‍♂️ Wie heeft ooit al eens iets met een website gedaan?
                </Typography>
              </Box>
            </Stack>
          ),
        },
        {
          label: "👵🏽 Terug in de tijd ",
          description: ``,
          content: (
            <Stack>
              <Grid container spacing={5}>
                <Grid size={6}>
                  <Typography variant="h5" mb={2}>
                    1991 - De allereerste webpagina (Tim Berners-Lee’s)
                  </Typography>
                  <Box
                    sx={{
                      height: 0,
                      width: "100%",
                      paddingBottom: "64%",
                      overflow: "hidden",
                      position: "relative",
                      borderRadius: 2,
                      boxShadow: 3,
                    }}
                  >
                    <iframe
                      title="x"
                      src="https://info.cern.ch/"
                      style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,

                        border: "1px solid #ccc",
                      }}
                    />
                  </Box>
                </Grid>
                <Grid size={6}>
                  <Typography variant="h5" mb={2}>
                    2025 - apple.com
                  </Typography>
                  <Box
                    component="video"
                    src="/presentation-data/KDAPPONT2/intro/apple_2.mov"
                    autoPlay
                    loop
                    muted
                    sx={{
                      width: "100%",
                      borderRadius: 2,
                      boxShadow: 3,
                    }}
                  />
                </Grid>
              </Grid>
              <Box>
                <Typography variant="h5">
                  🙋‍♂️ Wat zijn de voornaamste verschillen?
                </Typography>
              </Box>
            </Stack>
          ),
        },
        {
          label: "📝 Code editors ",
          description: ``,
          content: (
            <Grid container alignItems="center">
              <Grid size={4}>
                <List>
                  <ListItem>
                    <Typography variant="body1">
                      Visual Studio Code - (Portable!)
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="body1">WEBStorm</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="body1">PHPStorm</Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="body1">Brackets</Typography>
                  </ListItem>
                  <ListItem>...</ListItem>
                </List>
              </Grid>
              <Grid size={4}>
                <StyledImage src="/presentation-data/KDAPPONT2/intro/vscode.png"></StyledImage>
              </Grid>
            </Grid>
          ),
        },
        {
          label: "🧭 Webbrowsers",
          description: ``,
          content: (
            <Stack>
              <Grid container alignItems="center">
                <Grid size={4}>
                  <List>
                    <ListItem>
                      <Typography variant="body1">Chrome 🏆</Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">Safari</Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">Firefox</Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">Edge</Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">
                        Internet Exploder 💥
                      </Typography>
                    </ListItem>
                    <ListItem>
                      <Typography variant="body1">BrowserStack</Typography>
                    </ListItem>
                    <ListItem>...</ListItem>
                  </List>
                </Grid>
                <Grid size={4}>
                  <StyledImage src="/presentation-data/KDAPPONT2/intro/browsers.png"></StyledImage>
                </Grid>
              </Grid>
              <Box sx={{ mt: 3 }}>
                <Typography variant="h5">
                  🙋‍♂️ Wat is het verschil tussen client-side en server-side?
                </Typography>
              </Box>
            </Stack>
          ),
        },
        {
          label: "🤖 HTML (5)",
          description: ``,
          content: (
            <Grid container alignItems="center">
              <Grid size={9}>
                <List>
                  <ListItem>
                    <Typography variant="body1">
                      👉 HTML staat voor Hyper Text Markup Language.
                    </Typography>
                  </ListItem>
                  <List sx={{ pl: 15 }}>
                    <ListItem>
                      Hyper Text → tekst die meer kan dan gewone tekst. Denk aan
                      linkjes.
                    </ListItem>
                    <ListItem>
                      Markup → Je “markeert” delen van de tekst met tags om de
                      computer de context te laten begrijpen.
                    </ListItem>
                    <ListItem>
                      Language → Omdat het een gestructureerde taal met regels
                      is
                    </ListItem>
                  </List>
                  <ListItem>
                    <Typography variant="body1">
                      👉 HTML is de standaard opmaaktaal voor het maken van
                      webpagina's.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="body1">
                      👉 HTML beschrijft de structuur van een webpagina.
                      Essentieel voor zoekmachines.
                    </Typography>
                  </ListItem>
                  <ListItem>
                    <Typography variant="body1">
                      👉 HTML4 vs HTML5 standaard
                    </Typography>
                  </ListItem>
                  <List sx={{ pl: 15 }}>
                    <ListItem>
                      HTML4 (1997) → verouderd, weinig multimedia, veel
                      afhankelijk van plugins (Flash, Silverlight).
                    </ListItem>
                    <ListItem>
                      HTML5 (2014) → modern, ingebouwde ondersteuning voor
                      video, audio, canvas (games/tekenen), semantische tags
                      zoals &lt;header&gt;, &lt;footer&gt;, &lt;article&gt;, én
                      beter geschikt voor mobiel.
                    </ListItem>
                  </List>
                </List>
              </Grid>
              <Grid size={3}>
                <StyledImage src="/presentation-data/KDAPPONT2/intro/html.jpeg"></StyledImage>
              </Grid>
            </Grid>
          ),
        },
        {
          label: "👨🏼‍🏫 Demo",
          description: `Praktijkvoorbeelden`,
        },
        {
          label: "🖥️ WEB02 Server",
          description: `Kan iedereen nog inloggen? (FTP)`,
        },
        {
          label: "🚀 Digitaal Lesmateriaal - W3Schools - Aan de slag!",
          description: `Digitaal lesmateriaal ➡️ KD Appont ➡️ Module 1 :: HTML ➡️ LES 1`,
        },
      ]}
    />
  );
};
